// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container do calendário e atividades */
.calendario_calendarioPage__T3jZ1 {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.calendario_calendarContainer__u28if {
    display: flex;
    flex-direction: column;
    margin: 50px 2rem;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

@media (min-width: 768px) {
    .calendario_calendarIframe__RRv5Y {
        margin-top: 100px;
        flex: 1 1;
        margin-right: 2rem;
        border: none;
    }
    .calendario_calendarContainer__u28if {
        flex-direction: row;
        justify-content: space-between;
    }
}

.calendario_calendarIframe__RRv5Y {
    margin-top: 50px;
    flex: 1 1;
    margin-right: 2rem;
    border: none;
}

.calendario_cultosEventos__u2mKE {
    padding: 2rem;
    background-color: #ffffff;
    border-radius: 8px;
    margin: 50px 2rem;
}

.calendario_container__TvMCk {
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
}

h2 {
    font-size: 2rem;
    color: #074273;
    margin-bottom: 1.5rem;
}

ul {
    list-style: none;
    padding: 0;
}

.calendario_eventItem__tSy2j {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 1rem;
    margin-bottom: 0.75rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.calendario_eventDateContainer__uEHQq {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
    background-color: #00a0e4;
    color: white;
    border-radius: 6px;
    margin-right: 1rem;
    min-width: 70px;
    text-align: center;
}

.calendario_eventDate__efLRx {
    font-size: 1rem;
    font-weight: bold;
}

.calendario_eventTime__2FH2g {
    font-size: 0.875rem;
}

.calendario_eventDetails__gAelF {
    flex: 1 1;
    border-left: 3px solid #1e1e1e;
    padding-left: 1rem;
}

.calendario_eventTitle__WB7\\+l {
    font-size: 1.25rem;
    color: #074273;
    margin-bottom: 0.25rem;
}

.calendario_eventLocation__2TsVN {
    font-size: 0.875rem;
    color: #1e1e1e;
}`, "",{"version":3,"sources":["webpack://./src/pages/LIFTrac/Calendario/calendario.module.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI;QACI,iBAAiB;QACjB,SAAO;QACP,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,8BAA8B;IAClC;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":["/* Container do calendário e atividades */\r\n.calendarioPage {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n}\r\n\r\n.calendarContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 50px 2rem;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 20px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .calendarIframe {\r\n        margin-top: 100px;\r\n        flex: 1;\r\n        margin-right: 2rem;\r\n        border: none;\r\n    }\r\n    .calendarContainer {\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n    }\r\n}\r\n\r\n.calendarIframe {\r\n    margin-top: 50px;\r\n    flex: 1;\r\n    margin-right: 2rem;\r\n    border: none;\r\n}\r\n\r\n.cultosEventos {\r\n    padding: 2rem;\r\n    background-color: #ffffff;\r\n    border-radius: 8px;\r\n    margin: 50px 2rem;\r\n}\r\n\r\n.container {\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n}\r\n\r\nh2 {\r\n    font-size: 2rem;\r\n    color: #074273;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\nul {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.eventItem {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n    padding: 1rem;\r\n    margin-bottom: 0.75rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.eventDateContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 0.5rem;\r\n    background-color: #00a0e4;\r\n    color: white;\r\n    border-radius: 6px;\r\n    margin-right: 1rem;\r\n    min-width: 70px;\r\n    text-align: center;\r\n}\r\n\r\n.eventDate {\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.eventTime {\r\n    font-size: 0.875rem;\r\n}\r\n\r\n.eventDetails {\r\n    flex: 1;\r\n    border-left: 3px solid #1e1e1e;\r\n    padding-left: 1rem;\r\n}\r\n\r\n.eventTitle {\r\n    font-size: 1.25rem;\r\n    color: #074273;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.eventLocation {\r\n    font-size: 0.875rem;\r\n    color: #1e1e1e;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarioPage": `calendario_calendarioPage__T3jZ1`,
	"calendarContainer": `calendario_calendarContainer__u28if`,
	"calendarIframe": `calendario_calendarIframe__RRv5Y`,
	"cultosEventos": `calendario_cultosEventos__u2mKE`,
	"container": `calendario_container__TvMCk`,
	"eventItem": `calendario_eventItem__tSy2j`,
	"eventDateContainer": `calendario_eventDateContainer__uEHQq`,
	"eventDate": `calendario_eventDate__efLRx`,
	"eventTime": `calendario_eventTime__2FH2g`,
	"eventDetails": `calendario_eventDetails__gAelF`,
	"eventTitle": `calendario_eventTitle__WB7+l`,
	"eventLocation": `calendario_eventLocation__2TsVN`
};
export default ___CSS_LOADER_EXPORT___;
